import { render, staticRenderFns } from "./BorderSelectCard.vue?vue&type=template&id=8377e5ec&scoped=true"
import script from "./BorderSelectCard.vue?vue&type=script&lang=ts"
export * from "./BorderSelectCard.vue?vue&type=script&lang=ts"
import style0 from "./BorderSelectCard.vue?vue&type=style&index=0&id=8377e5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8377e5ec",
  null
  
)

export default component.exports